import { render, staticRenderFns } from "./StandardModelFieldComponent.vue?vue&type=template&id=10674fce&scoped=true&"
import script from "./StandardModelFieldComponent.vue?vue&type=script&lang=js&"
export * from "./StandardModelFieldComponent.vue?vue&type=script&lang=js&"
import style0 from "./StandardModelFieldComponent.vue?vue&type=style&index=0&id=10674fce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10674fce",
  null
  
)

export default component.exports